import { loadable } from '@shared/core/loadableFromNamedExport';

// Autocomplete pulls in Command + PopoverV2 synchronously, and the name-affix fields are
// feature-flagged — lazy keeps that machinery out of each form's initial chunk when the flag is off.
export const LazyNameAffixField = loadable(() => import(/* webpackChunkName: "shared/name-affix-field" */ './NameAffixField'), 'NameAffixField');
